<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCurrencyExchange">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>
            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [width]="'5.5rem'" [icon]="'pi pi-plus'" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="currencyExchangeContract.userNameCreate"
              [createDate]="currencyExchangeContract.createDate"
              [userNameUpdate]="currencyExchangeContract.userNameUpdate"
              [updateDate]="currencyExchangeContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-currency">
              <app-custom-select formControlName="currencyId" [labelText]="'Moneda'" [list]="listCurrencies"
                [required]="true" [recovery]="true" (onChangeSelect)="changeCurrency($event)"></app-custom-select>
            </div>
            <div class="col field-dateExchange">
              <app-custom-datepicker formControlName="dateExchange" [labelText]="'Fecha'" [required]="true"
                [recovery]="true" (onChangeDate)="changeDateExchange()"></app-custom-datepicker>
            </div>
            <div class="col field-valueExchange">
              <app-custom-input-decimal formControlName="valueExchange" [labelText]="'Vr. Cambio'">
              </app-custom-input-decimal>
            </div>
            <div class="col field-button">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>